import { Box } from '@mui/material';
import { ReportSectionComponentType } from '../types';
import { useReportUpdater } from '../hooks/useReportUpdater';
import EmptySectionWarning from '../components/emptySectionWarning';
import ReportSectionFiles from '../components/reportSectionFiles';
import StepFooter from '../../common/components/stepFooter';

/**
 * Report SLA step
 */
const SlaStep: ReportSectionComponentType = ({
  sectionName,
  report,
  templateFileUrl,
  onClickBack,
  onClickNext,
  isLoading: isSomethingLoading,
}) => {
  const { isLoading, saveChanges, sectionData, addFile, removeFile, setPropertyValue } =
    useReportUpdater({
      report,
      sectionName,
    });

  const handleClickNext = (): void => {
    saveChanges().then(() => onClickNext());
  };

  if (!sectionData) {
    return <EmptySectionWarning />;
  }

  return (
    <Box>
      {templateFileUrl && (
        <ReportSectionFiles
          addFile={addFile}
          removeFile={removeFile}
          sectionData={sectionData}
          templateFileUrl={templateFileUrl}
          setPropertyValue={setPropertyValue}
        />
      )}
      <StepFooter
        isLoading={isLoading || isSomethingLoading}
        onClickBack={onClickBack}
        onClickNext={handleClickNext}
      />
    </Box>
  );
};

export default SlaStep;
